import { render, staticRenderFns } from "./Calendly.vue?vue&type=template&id=52a95f66&"
import script from "./Calendly.vue?vue&type=script&lang=js&"
export * from "./Calendly.vue?vue&type=script&lang=js&"
import style0 from "./Calendly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports